import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const PCS_LOAD = 'PCS_LOAD'
export const PC_LOAD = 'PC_LOAD'
export const PC_CREATE = 'PC_CREATE'
export const PC_UPDATE = 'PC_UPDATE'
export const PC_DESTROY = 'PC_DESTROY'
export const PC_STATE_UPDATE = 'PC_STATE_UPDATE'

const pcsApi = new Api(UrlStore.PCS)
const pcSchema = new schema.Entity('pcs')

export const extractPcs = (context, points) => {
  let pcs = []
  points.forEach((point) => {
    if (point.pc) {
      pcs.push(point.pc)
      point.pc = point.pc.id
    }
  })
  if (pcs.length) {
    context.commit('pc/' + PCS_LOAD, { items: pcs }, { root: true })
  }
}

export default {
  namespaced: true,
  state: {
    pcsLoaded: false,
    pcsList: [],
    entities: {
      pcs: {}
    }
  },
  getters: {
    pcs(state) {
      return state.pcsList.map((bId) => state.entities.pcs[bId])
    },
    getPc: (state) => (pcId) => state.entities.pcs[pcId] || null
  },
  mutations: {
    [PCS_LOAD](state, payload) {
      let normData = normalize(payload.items, [pcSchema])
      state.pcsList = normData.result
      setEntities(state, normData)
    },
    [PC_LOAD](state, payload) {
      let normData = normalize(payload, pcSchema)
      setEntities(state, normData)
    },
    [PC_CREATE](state, pc) {
      state.pcsList.push(pc.id)
      Vue.set(state.entities.pcs, pc.id, pc)
    },
    [PC_UPDATE](state, pc) {
      if (pc.id && state.entities.pcs[pc.id]) {
        state.entities.pcs[pc.id] = Object.assign({}, state.entities.pcs[pc.id], pc)
      }
    },
    [PC_DESTROY](state, pc) {
      let num = state.pcsList.findIndex((cId) => cId === pc.id)
      if (num !== -1) {
        state.pcsList.splice(num, 1)
        delete state.entities.pcs[pc.id]
      }
    },
    [PC_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    pcsLoad({ commit }, config = {}) {
      pcsApi.getAll(config).then((r) => {
        commit(PCS_LOAD, r.data)
        commit(PC_STATE_UPDATE, { pcsLoaded: true })
      })
    },
    pcLoad({ commit }, config) {
      pcsApi.get({ id: config.id, config: config }).then((r) => {
        commit(PC_LOAD, r.data)
      })
    },
    pcSave({ commit, getters }, { pc, config = {} }) {
      if (!pc.id) throw new Error('Pc id is not present in `pcSave`!')
      commit(getters.getPc(pc.id) ? PC_UPDATE : PC_CREATE, pc)
      let pcUpdated = getters.getPc(pc.id)

      return pcsApi.save(pcUpdated, config).then((r) => {
        if (r._isNew) {
          commit(PC_DESTROY, pcUpdated) // local
          commit(PC_CREATE, r.data)
          if (r.data.point_id) {
            commit(`point/POINT_UPDATE`, { id: r.data.point_id, pc: r.data.id }, { root: true })
          }
        } else {
          commit(PC_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    pcDestroy({ commit }, pc) {
      pcsApi.destroy({ id: pc.id }).then(() => {
        commit(PC_DESTROY, pc)
      })
    }
  }
}
